// Cross-browser fullscreen API
// http://www.javascriptkit.com/javatutors/javascriptfullscreenapi.shtml
function getFullscreenEventName() {
  const root = document.documentElement
  const fullscreenEvents = {
    requestFullscreen: 'fullscreenchange',
    webkitRequestFullscreen: 'webkitfullscreenchange',
    mozRequestFullScreen: 'mozfullscreenchange',
    msRequestFullscreen: 'msfullscreenchange',
  }

  for (let method in fullscreenEvents) {
    if (root[method]) {
      // if root document object supports this requestFullscreen method
      return fullscreenEvents[method]
    }
  }
}

export function addFullscreenListener(callback) {
  const fullscreenEventName = getFullscreenEventName()
  if (fullscreenEventName) {
    document.addEventListener(fullscreenEventName, callback)
  }
}

export function removeFullscreenListener(callback) {
  const fullscreenEventName = getFullscreenEventName()
  if (fullscreenEventName) {
    document.removeEventListener(fullscreenEventName, callback)
  }
}

export function requestFullscreen(element) {
  const videoElement = element.querySelector('video')
  if (element.requestFullscreen) {
    return element.requestFullscreen({ navigationUI: 'hide' })
  }
  if (element.mozRequestFullScreen) {
    /* Firefox */
    return element.mozRequestFullScreen()
  }
  if (element.webkitRequestFullscreen) {
    /* Chrome, Safari and Opera */
    return element.webkitRequestFullscreen({ navigationUI: 'hide' })
  }
  if (element.msRequestFullscreen) {
    /* IE/Edge */
    return element.msRequestFullscreen()
  }
  /* iOS browsers */
  if (videoElement.webkitEnterFullscreen) {
    videoElement.webkitEnterFullscreen()
  }
}

export function getFullscreenElement() {
  return (
    document.fullscreenElement ||
    document.webkitFullscreenElement ||
    document.mozFullScreenElement ||
    document.msFullscreenElement
  )
}

export function isFullscreenEnabled() {
  return Boolean(getFullscreenElement())
}

export function exitFullscreen() {
  const exit =
    document.exitFullscreen ||
    document.webkitExitFullscreen ||
    document.mozCancelFullScreen ||
    document.msExitFullscreen
  return exit.call(document)
}
